import React, { useMemo } from 'react';

import type { PageHeaderToolbarProps } from '../../types';

import { ActionButton } from './components/ActionButton';
import { toolbar as toolbarStyles } from './PageHeaderToolbar.styles';

export const PageHeaderToolbar: React.FC<PageHeaderToolbarProps> = ({
	actionButtons = [],
	mobile = false,
	buttonVariant = 'default',
}: PageHeaderToolbarProps) => {
	const styles = toolbarStyles({ isMobile: mobile, buttonVariant });

	const sortedActionButtons = useMemo(() => {
		return mobile ? [...actionButtons].reverse() : actionButtons;
	}, [actionButtons, mobile]);

	return (
		<nav className={styles} data-testid="page-header-actions" aria-label="Page actions">
			{sortedActionButtons.map((buttonType) => (
				<ActionButton
					data-testid={`header-button-${buttonType}`}
					data-qa={`header-button-${buttonType}`}
					key={`header-button-${buttonType}`}
					actionType={buttonType}
					variant={buttonVariant}
				/>
			))}
		</nav>
	);
};
